"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renewal = void 0;
class Renewal {
    get _id() {
        return this.id;
    }
    set _id(val) {
        this.id = val;
    }
}
exports.Renewal = Renewal;
//# sourceMappingURL=Renewal.js.map